import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ef4c243c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "analytics" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "analytics__contents"
}
const _hoisted_4 = { class: "d-flex justify-end" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Deleting... ", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " No transcription available for the selected date.", -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_transcription_item = _resolveComponent("transcription-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_unique_word_number = _resolveComponent("unique-word-number")!
  const _component_word_chart = _resolveComponent("word-chart")!
  const _component_suggestion_item = _resolveComponent("suggestion-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "analytics__date" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              variant: "outlined",
              onClick: _ctx.previousDay,
              icon: "mdi-chevron-left"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_menu, {
              modelValue: _ctx.menu,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.menu) = $event)),
              "close-on-content-click": false,
              "nudge-right": 40,
              transition: "scale-transition",
              "offset-y": "",
              "min-width": "auto"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_text_field, _mergeProps({
                  modelValue: _ctx.formattedDate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formattedDate) = $event)),
                  label: "Select Date",
                  "prepend-icon": "mdi-calendar",
                  readonly: ""
                }, props), null, 16, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_date_picker, {
                  modelValue: _ctx.selectedDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event)),
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.menu = !_ctx.menu))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              variant: "outlined",
              onClick: _ctx.nextDay,
              icon: "mdi-chevron-right"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 0,
                indeterminate: "",
                size: "64",
                color: "primary"
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcriptions, (transcription) => {
            return (_openBlock(), _createElementBlock("div", {
              key: transcription.id
            }, [
              _createVNode(_component_v_card, {
                variant: "outlined",
                class: "analytics__contents__card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_v_btn, {
                          variant: "flat",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmDelete = true)),
                          icon: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { color: "error" }, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-delete")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("audio", {
                    class: "analytics__contents__audio",
                    src: transcription.download_url,
                    controls: ""
                  }, null, 8, _hoisted_5),
                  _createVNode(_component_transcription_item, {
                    transcription: transcription,
                    class: "analytics__contents__card__transcriptions"
                  }, null, 8, ["transcription"]),
                  _createVNode(_component_v_divider, { class: "analytics__contents__card__divider" }),
                  (_ctx.getWordCountByTranscriptionId(transcription.id).value)
                    ? (_openBlock(), _createBlock(_component_unique_word_number, {
                        key: 0,
                        "word-count": _ctx.getWordCountByTranscriptionId(transcription.id).value,
                        class: "analytics__contents__card__word-counts"
                      }, null, 8, ["word-count"]))
                    : _createCommentVNode("", true),
                  (_ctx.getWordCountByTranscriptionId(transcription.id).value)
                    ? (_openBlock(), _createBlock(_component_word_chart, {
                        key: 1,
                        "word-count": _ctx.getWordCountByTranscriptionId(transcription.id).value
                      }, null, 8, ["word-count"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_divider, { class: "analytics__contents__card__divider" }),
                  _createVNode(_component_suggestion_item, {
                    suggestion: _ctx.getSuggestionByTranscriptionId(transcription.id).value,
                    uid: _ctx.uid,
                    transcriptionId: transcription.id,
                    selectedDate: _ctx.selectedDate,
                    class: "analytics__contents__card__suggestions"
                  }, null, 8, ["suggestion", "uid", "transcriptionId", "selectedDate"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_dialog, {
                modelValue: _ctx.confirmDelete,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmDelete) = $event)),
                persistent: "",
                "max-width": "300"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, { class: "text-center" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Will you delete the transcription? ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            onClick: ($event: any) => (_ctx.deleteContent(transcription.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Yes")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmDelete = false))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("No")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["modelValue"]),
              _createVNode(_component_v_dialog, {
                modelValue: _ctx.isDeleting,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isDeleting) = $event)),
                persistent: "",
                "max-width": "300"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, { class: "text-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            size: "64"
                          }),
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          }), 128)),
          (_ctx.transcriptions.length < 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true)
        ]))
  ]))
}